import { render, staticRenderFns } from "./CallOriginatorRules.vue?vue&type=template&id=74cb4d41&"
import script from "./CallOriginatorRules.vue?vue&type=script&lang=ts&"
export * from "./CallOriginatorRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports